'use client'
const PHONE_NUMBER_REGEX = /^(\+[1-9]\d{1,14})?$/;
// Reserved fields
const NAME_SERVICE_FIELD_NAME = 'name-service-subdomain-handle';

export { NAME_SERVICE_FIELD_NAME, PHONE_NUMBER_REGEX };
